import React from 'react'
import PropTypes from 'prop-types'
import ButtonTheme from '~/components/common/Button'

const Button = ({ field, onClick, disabled, form, ...props }) => (
  <ButtonTheme
    onClick={() => onClick(field.value)}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

Button.defaultProps = {
  onClick: () => {},
  disabled: false,
}

Button.propTypes = {
  field: PropTypes.shape().isRequired,
  form: PropTypes.shape().isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

export default Button
